<template>
  <div v-if="ready" class="container">
    <div class="row mat24">
      <div class="col-lg-12 dashboard">
        <div class="dashboard-wrapper">
          <div v-if="competitionSetting.canQR === false" class="insurance">
            <div class="insurance-status">
              <img src="@/assets/images/close-circle.svg" alt="" />
              <h2>Kody QR nieaktywne</h2>
            </div>
            <div class="insurance-content">
              <p><b>Uczestnicy będą automatycznie dostawać kody QR w mailu z rejestracją.</b></p>
              <p>Dzięki temu odbierze pakiet startowy w prostszy sposób.</p>
            </div>
            <base-button btn1 @click="save('on')">Włącz Kody QR</base-button>
          </div>

          <div v-else-if="competitionSetting.canQR" class="insurance">
            <div class="insurance-status active mb-4">
              <img src="@/assets/images/checkmark-circle.svg" alt="" />
              <h2 class="text-green">Kody QR aktywne</h2>
            </div>
            <base-button btn2 @click="save('off')">Wyłącz Kody QR</base-button>
          </div>
        </div>
      </div>
      <div v-if="competitionSetting.canQR" class="col-12 mt-4">
        <div class="add-point-wrapper">
          <h3>Dodaj nowy czytnik QR</h3>
          <div class="row align-items-center mat24">
            <div class="col-lg-6 col-12">
				<div class="input-field">
					<input 
						type="text" 
						class="input-field__input" 
						v-model="newPointIdentifier" 
						placeholder="Nazwa punktu (np. brama-wschodnia)"
					>
			  	</div>
            </div>
            <div class="col-lg-3 col-12 mt-2 mt-lg-0">
              <base-button btn1 @click="createPickUpPoint" :disabled="!newPointIdentifier">
                Generuj nowy czytnik
              </base-button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="competitionSetting.canQR && pickUpPoints.length > 0" class="col-12 mt-4">
        <div v-for="point in pickUpPoints" :key="point.id" class="point-card mat24">
          <div class="row">
            <div class="col-lg-8 col-12 d-flex flex-column">
              <div class="point-header">
                <h3>Punkt: {{ point.identifier === '1' ? 'Główny' : point.identifier }}</h3>
                <small class="text-muted small">Utworzono: {{ point.createdAt }}</small>
              </div>
              
              <div class="mat16">Link do czytnika:</div>
              <div class="mat8 border-box--gray checkpoint__link align-items-center justify-content-space-between mt-2">
                <p class="mb-0">{{ getLink(point) }}</p>
                <base-button
                  btn9
                  icon="far fa-link"
                  class="mt-4 mt-lg-0 ml-lg-3 flex-shrink-0"
                  @click="copyLink(getLink(point))"
                >
                  Kopiuj
                </base-button>
              </div>
            </div>
            <div class="col-lg-4 col-12 mt-4 mt-lg-0 text-center">
              <div class="qr-wrapper">
                <p class="mb-2">Kod QR do skanera</p>
                
                <div v-if="qrImages[point.identifier]" class="qr-image-box">
                  <img :src="qrImages[point.identifier]" alt="QR Code" />
                </div>
                <div v-else class="qr-loading">
                  <i class="fas fa-spinner fa-spin"></i> Generowanie...
                </div>

                <div class="player-count mat8">
                  <span class="count-badge">
                    Zeskanowano osób: <strong>{{ point.playerCount }}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'PanelCompetitionSettingScannerQR',
  props: {
    id: {
      type: Number,
      required: true,
    },
    competition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ready: true,
      pickUpPoints: [],
      qrImages: {},
      newPointIdentifier: '',
    };
  },
  computed: {
    ...mapGetters(['competitionsSettings', 'token']),
    competitionSetting() {
      return this.competitionsSettings[this.id];
    },
  },
  created() {
    if (this.competitionSetting.canQR) {
      this.initData();
    }
  },
  methods: {
    async initData() {
      await this.getPickUpPoints();
    },
    async save(availability) {
      try {
        this.ready = false;
        await axios.put(`panel/competitions/${this.id}/settings`, {
          canQR: availability === 'on',
        });
        if (this.competitionSetting) {
            this.competitionSetting.canQR = availability === 'on';
        }

        if (availability === 'on') {
          await this.initData();
        } else {
            this.pickUpPoints = [];
            this.qrImages = {};
        }
      } catch (e) {
        console.error('Error saving scanner QR setting', e);
      } finally {
        this.ready = true;
      }
    },
    async getPickUpPoints() {
      try {
        const res = await axios.get(`qr/competition/${this.id}/pickup-points`);
        this.pickUpPoints = res;
        this.pickUpPoints?.forEach(point => {
            this.generateQRCode(point.identifier);
        });
      } catch (e) {
        console.error('Error fetching pickup points', e);
      }
    },
    async createPickUpPoint() {
        if (!this.newPointIdentifier) return;
        
        try {
            await axios.get(`qr/generate/competition/${this.id}/${this.newPointIdentifier}`);
            
            this.newPointIdentifier = '';
            await this.getPickUpPoints();
        } catch (e) {
            console.error('Error creating pickup point', e);
            alert('Wystąpił błąd podczas tworzenia punktu.');
        }
    },
    async generateQRCode(identifier) {
      if (this.qrImages[identifier]) return;

      try {
        let url = `qr/generate/competition/${this.id}`;
        if (identifier && identifier !== '1') {
            url += `/${identifier}`;
        }

        const res = await axios.get(url, {
          responseType: 'blob',
          headers: {
            'X-Access-Token': this.token,
          },
        });

        let blob = res && res.data instanceof Blob ? res.data : res;
        if (!(blob instanceof Blob)) blob = new Blob([blob]);

        const contentType = blob.type || '';
        if (contentType.startsWith('image/')) {
            const imageUrl = URL.createObjectURL(blob);
            this.qrImages = { ...this.qrImages, [identifier]: imageUrl };
        }
      } catch (e) {
        console.error(`Error generating QR for ${identifier}`, e);
      }
    },
    getLink(point) {
      const host = window.location.origin;
      const baseUrl = `${host}/qrreader-${this.competition.apiKey}`;
      
      if (point.identifier === '1') {
        return baseUrl;
      }
      
      return `${baseUrl}?pickuppoint=${point.identifier}`;
    },

    copyLink(link) {
      const el = document.createElement('textarea');
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    },
  },
};
</script>

<style scoped>
.text-green {
  color: var(--color-dark-pastel-green);
}
.dashboard {
  overflow: hidden;
}
.insurance {
  background: #455a64;
  border-radius: 4px;
  padding: 32px;
  margin-bottom: 24px;
}
.insurance-status {
  background: #546e7a;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 26px 22px;
}
.insurance-status.active {
  background: #edf6ee;
}
.insurance-status img {
  margin-right: 22px;
}
.insurance-content {
  margin-top: 40px;
  margin-bottom: 32px;
  color: #fff;
}
.insurance-content p b {
  font-size: 16px;
  font-weight: 600;
}
.insurance-content p {
  margin-bottom: 16px;
}
.insurance >>> .btn {
  display: inline-flex;
  min-width: 208px;
}

.add-point-wrapper {
  background: #455a64;
  padding: 32px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.point-card {
  background: #455a64;
  border-radius: 4px;
  padding: 32px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  margin-bottom: 24px;
}

.point-header h3 {
    margin: 0;
    font-size: 1.2rem;
    font-weight: 600;
}

.checkpoint__link {
  display: flex;
  flex-wrap: wrap;
  color: var(--color-greyish-brown);
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
}

.checkpoint__link p {
	font-size: 10px;
}

.qr-wrapper {
  background: #fff;
  border: 1px solid #eee;
  padding: 16px;
  border-radius: 8px;
  display: inline-block;
  min-width: 200px;
}

.qr-image-box img {
  max-width: 100%;
  height: auto;
  max-height: 200px;
  display: block;
  margin: 0 auto;
}

.qr-loading {
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
}

.count-badge {
    background-color: #455a64;
    color: #fff;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.9rem;
}

/* Utilities */
.mat8 { margin-top: 8px; }
.mat16 { margin-top: 16px; }
.mat24 { margin-top: 24px; }
.mb-4 { margin-bottom: 1.5rem; }
.ml-3 { margin-left: 1rem; }
.mt-4 {margin-top: 4px;}
.flex-shrink-0 { flex-shrink: 0; }
.text-truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap;}
@media (min-width: 992px) {
  .dashboard-wrapper {
    margin-right: 0;
  }
  .ml-lg-3 { margin-left: 1rem; }
  .mt-lg-0 {
	margin-top: 0;
  }
}
</style>
